import React, { createContext, useEffect, useState, useRef } from 'react';

export const ComponentContext = createContext();

const ComponentProvider = props => {
  const [steps, setSteps] = useState(null);
  const [tiers, setTiers] = useState(null);
  const [bundle, setBundle] = useState([]);


  useEffect(() => {
    const stepsJson = document.querySelectorAll('[bundle-builder-step')
    const tiersJson = document.querySelector('[bundle-builder-tiers')

    const stepsData = Array.from(stepsJson).map(step => JSON.parse(step.innerText))
    setSteps(stepsData)

    const tiersData = JSON.parse(tiersJson.innerText)
    setTiers(tiersData)
  }, [])

  return (
    // this is the provider providing state
    <ComponentContext.Provider value={{
      tiersState: [tiers, setTiers],
      stepsState: [steps, setSteps],
      bundleState: [bundle, setBundle]
    }}>
      {props.children}
    </ComponentContext.Provider>
  );
}

export default ComponentProvider
/* {
      artistsState: [artistsState, setArtistsState],
      filteredArtistsState: [filteredArtistsState, setFilteredArtistsState],
      sortingValueState: [sortingValueState, setSortingValueState],
      activeState: [activeState, setActiveState],
      mobileDrawerState: [drawerIsOpenState, setDrawerIsOpenState]
    } */